<template lang="pug">
    aside.sidebar.menu(
        :class="{ 'is-expanded': isExpanded || isHover}"
        @mouseover="hoverOn"
        @mouseleave="isHover=false")
        .container
            p.menu-label
                Logo
                a.navbar-burger(
                    :class="{ 'is-expanded': isExpanded}"
                    role="button"
                    aria-label="menu"
                    aria-expanded="false"
                    @click="toggle")
                    span(aria-hidden="true")
                    span(aria-hidden="true")
                    span(aria-hidden="true")
            ul.menu-list
                li(v-for="item in menu")
                    router-link(@click.native="linkToggle" :to="item.link" :title="item.title" :exact="item.link === '/'")
                        span.icon
                            i(:class="[item.icon, item.icon === 'fa-telegram-plane' ? 'fab' : 'fas']")
                        span.link-title {{ item.title }}
                li
                    a(@click="logout" title="Log out")
                        span.icon
                            i.fas.fa-sign-out-alt
                        span.link-title Log out
</template>

<script>
import Logo from "./Logo";

export default {
  name: "Sidebar",
  components: {
    Logo
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      isExpanded: false,
      isHover: false,
      menu: [
        {
          title: "Dashboard",
          icon: "fa-tachometer-alt",
          link: "/"
        },
        {
          title: "Live",
          icon: "fa-bolt",
          link: "/live"
        },
        {
          title: "Profiles",
          icon: "fa-filter",
          link: "/profiles"
        },
        {
          title: "Ticker",
          icon: "fa-bars",
          link: "/ticker"
        },
        {
          title: "Prematch",
          icon: "fa-list",
          link: "/prematch"
        },
        {
          title: "Data",
          icon: "fa-database",
          link: "/data"
        },
        {
          title: "Users",
          icon: "fa-users",
          link: "/users"
        },
        {
          title: "Subscription",
          icon: "fa-money-check-alt",
          link: "/subscription"
        },
        {
          title: "Social",
          icon: "fa-share-alt",
          link: "/social"
        },
        {
          title: "Ads",
          icon: "fa-bullhorn",
          link: "/ads"
        },
        // {
        //   title: "Restart App",
        //   icon: "fa-sync-alt",
        //   link: "/restart"
        // }
        {
          title: "Settings",
          icon: "fa-cogs",
          link: "/settings"
        },
        {
          title: "Admins",
          icon: "fa-user-cog",
          link: "/admin"
        }
      ]
    };
  },
  computed: {
    smallWindow() {
      return this.windowWidth <= 769;
    }
  },
  methods: {
    // hover expands the whole sidebar, not just the logo row; on touch layouts
    // the burger stays the only way to open it
    hoverOn() {
      if (!this.smallWindow) this.isHover = true;
    },
    toggle() {
      this.isExpanded = !this.isExpanded;
      if (!this.isExpanded) this.isHover = this.isExpanded;
    },
    linkToggle() {
      if (this.smallWindow) this.isExpanded = this.isHover = false;
    },
    logout() {
      this.$store
        .dispatch("logout")
        .catch(text => {
          this.$notify({
            type: "error",
            title: "Log out error",
            text
          });
        })
        .finally(() => {
          if (!this.$store.getters.isAuth && this.$route.fullPath !== "/")
            this.$router.push("/");
        });
    }
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  }
};
</script>

<style lang="scss" scoped>
$bg: #212121;
$linkColor: #fff;
$linkBG: #008c67;

aside.sidebar {
  order: 1;
  min-width: 5.5rem;
  background-color: $bg;
  font-size: 20px;
  overflow-y: auto;

  @media screen and (max-width: $tablet) {
    overflow: initial;
  }

  .container {
    position: relative;
    max-height: 100%;
  }

  .menu-label {
    display: flex;
    align-items: center;
    font-size: 0.75em;
    justify-content: center;

    @media screen and (max-width: $tablet) {
      margin: 0 !important;
      justify-content: flex-end;
    }

    &:not(:last-child) {
      margin-bottom: 1rem;
    }

    .logo {
      width: 85%;

      @media screen and (max-width: $tablet) {
        width: calc(100% - 6.5rem);
      }
    }

    .navbar-burger {
      display: flex;
      max-width: 0;
      margin: 0;
      overflow: hidden;

      @media screen and (max-width: $tablet) {
        max-width: 100% !important;
      }

      &.is-expanded {
        max-width: 100%;
      }

      &:hover {
        background-color: $linkBG;
      }

      span {
        background-color: $linkColor;
      }
    }
  }

  .menu-list {
    @media screen and (max-width: $tablet) {
      position: fixed;
      top: auto;
      width: 100%;
      height: 100%;
      max-height: calc(100% - 3.25rem);
      z-index: 10;
      background-color: $bg;
      display: none;
      overflow-y: auto;

      .link-title {
        display: block !important;
        max-width: 100% !important;
        overflow: hidden;
      }
    }

    a {
      display: flex;
      align-items: center;
      padding: 1rem 1.5rem;
      color: $linkColor;
      border-radius: 0;

      .icon {
        margin: 0 0.5rem;
      }

      .link-title {
        display: none;
        max-width: 0;
        overflow: hidden;
        font-size: 1.2rem;
      }

      &:hover,
      &.router-link-active {
        background-color: $linkBG;
      }
    }
  }

  &.is-expanded {
    min-width: 14rem;

    @media screen and (max-width: $tablet) {
      height: 100%;
    }

    .navbar-burger {
      max-width: 100%;
    }

    .menu-label {
      @media screen and (min-width: $tablet+1) {
        justify-content: flex-end;
        font-size: 1.3em;

        .logo {
          width: calc(80% - 3.25rem);
          margin-right: 10%;
        }
      }
    }

    .menu-list {
      @media screen and (max-width: $tablet) {
        display: block;
      }

      a {
        .link-title {
          display: block;
          max-width: 100%;
        }
      }
    }
  }
}
</style>
